export default {
	availableAccounts: state => state.availableAccounts,
	userTokenData: state => state.userTokenData
};
